const mediaItems = [
  { title: '繁花 · 沪上风云', duration: '03:25', type: '预告片', views: '128万' },
  { title: '庆余年第二季 · 重磅回归', duration: '04:12', type: '片花', views: '256万' },
  { title: '狂飙 · 高能名场面', duration: '02:48', type: '精彩剪辑', views: '189万' },
  { title: '长相思 · 催泪名场面', duration: '03:56', type: '片段', views: '143万' },
  { title: '南来北往 · 温情时刻', duration: '02:35', type: '幕后花絮', views: '97万' },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-600 text-xs font-medium mb-3">
            <i className="ri-play-circle-line"></i>
            精彩看点
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精彩片花
          </h2>
          <p className="text-sm text-foreground-500 mt-2">热门剧集高能片段与精彩预告，抢先一睹为快</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="aspect-video relative overflow-hidden bg-secondary-800">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center transition-transform group-hover:scale-110">
                    <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded bg-black/60 text-white text-[10px] font-medium">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2 px-2 py-1 rounded bg-accent-500 text-white text-[10px] font-medium">
                  {item.type}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-400 mt-1">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}